import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import useClearCartModal from '@features/cart/hooks/useClearCart'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



export default function ClearCart () {
  const { t: tca } = useTranslation('cart')
  const { openClearCartModal } = useClearCartModal()

  return (
    <button
      type="button"
      className={cn(styles.root, 'reset-button')}
      onClick={openClearCartModal}
    >
      <ReactSVG src="/icons/trash.svg" wrapper="span" />{' '}
      <span>{tca('preview.clear_button')}</span>
    </button>
  )
}